'use strict';
import * as $j_app$002eapi$002e$002dClient$002dType from "./app.api.-Client-Type.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_ClientType$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.Lapp_api_ClientType$$anon$1__f_$name$1 = null;
  this.Lapp_api_ClientType$$anon$1__f__$ordinal$1 = 0;
  this.Lapp_api_ClientType$$anon$1__f_$name$1 = \u03b4name$2;
  this.Lapp_api_ClientType$$anon$1__f__$ordinal$1 = _$ordinal$2;
}
export { $c_Lapp_api_ClientType$$anon$1 as $c_Lapp_api_ClientType$$anon$1 };
$c_Lapp_api_ClientType$$anon$1.prototype = new $j_app$002eapi$002e$002dClient$002dType.$h_Lapp_api_ClientType();
$c_Lapp_api_ClientType$$anon$1.prototype.constructor = $c_Lapp_api_ClientType$$anon$1;
/** @constructor */
function $h_Lapp_api_ClientType$$anon$1() {
}
export { $h_Lapp_api_ClientType$$anon$1 as $h_Lapp_api_ClientType$$anon$1 };
$h_Lapp_api_ClientType$$anon$1.prototype = $c_Lapp_api_ClientType$$anon$1.prototype;
$c_Lapp_api_ClientType$$anon$1.prototype.productArity__I = (function() {
  return 0;
});
$c_Lapp_api_ClientType$$anon$1.prototype.productElement__I__O = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Lapp_api_ClientType$$anon$1.prototype.productElementName__I__T = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Lapp_api_ClientType$$anon$1.prototype.productPrefix__T = (function() {
  return this.Lapp_api_ClientType$$anon$1__f_$name$1;
});
$c_Lapp_api_ClientType$$anon$1.prototype.toString__T = (function() {
  return this.Lapp_api_ClientType$$anon$1__f_$name$1;
});
$c_Lapp_api_ClientType$$anon$1.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I(this.Lapp_api_ClientType$$anon$1__f_$name$1);
});
$c_Lapp_api_ClientType$$anon$1.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lapp_api_ClientType$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_ClientType$$anon$1, "app.api.ClientType$$anon$1", ({
  Lapp_api_ClientType$$anon$1: 1,
  Lapp_api_ClientType: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lapp_api_ClientType$$anon$1 as $d_Lapp_api_ClientType$$anon$1 };
//# sourceMappingURL=app.api.-Client-Type$$anon$1.js.map
